import { Badge, Text } from "@mantine/core";
import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";

interface ActionStatusBadgeProps {
  size?: string;
  task: JobTaskDetailSchema;
  resultField: string;
  // Force an "Unanswered" badge regardless of the stored value — used when a
  // downstream question is moot because a prerequisite question wasn't answered
  // "Yes" (e.g. Q3 product match when Q2 item detection is unanswered/No).
  forceUnanswered?: boolean;
}

export const ActionStatusBadge = (props: ActionStatusBadgeProps) => {
  const { task, resultField, forceUnanswered } = props;

  const getBadgeColor = () => {
    if (forceUnanswered) {
      return "gray";
    }
    if (task?.result?.[resultField]) {
      return "green";
    }
    if (task?.result?.[resultField] === false) {
      return "red";
    }
    if (task?.result?.[resultField] === undefined) {
      return "gray";
    }
    if (task?.result?.[resultField] === null) {
      return "gray";
    }
  };

  const getBadgeText = () => {
    if (forceUnanswered) {
      return "Unanswered";
    }
    if (task?.result?.[resultField]) {
      return "✓ Yes";
    }
    if (task?.result?.[resultField] === false) {
      return "✗ No";
    }
    if (task?.result?.[resultField] === undefined) {
      return "Pending";
    }
    if (task?.result?.[resultField] === null) {
      return "Unanswered";
    }
  };

  return (
    <div
      className={`flex ${resultField === "is_correct" ? "items-center" : "items-start"} flex-col`}
    >
      <Text size="sm" c="dimmed" mb="xs">
        Acceptable for publishing?
      </Text>
      <Badge size={props.size || "md"} color={getBadgeColor()} variant="filled">
        {getBadgeText()}
      </Badge>
    </div>
  );
};
